import $ from 'jquery';
import debounce from "./utils/debounce";

class ToggleOpenMobileOnly {
    constructor (groupHeading, groupWrapper) {
        this.$window       = $(window);
        this.$heading      = $(groupHeading);
        this.$contentClass = groupWrapper;
        this.$content      = $(groupWrapper);

        this.$heading.on('click', $.proxy(this.buttonClick, this));

        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > 767) {
                this.$heading.removeClass('is-clicked');
                this.$content.removeAttr('style');
            } else {
                this.$content.hide();
            }
        }, 50));
    }

    buttonClick (e) {
        const $elem           = $(e.currentTarget);
        const $anchorListItem = $elem.parents('.js-anchor-list-item');

        if (this.$window.width() <= 767) {
            if ($anchorListItem.hasClass('has-sub-nav')) {
                e.preventDefault();
            }

            this.$heading.toggleClass('is-clicked').next(this.$contentClass).slideToggle();
        }
    }
}

export default ToggleOpenMobileOnly;
